import React, { useEffect, useState } from 'react';
import { array, bool, func, node, string } from 'prop-types';

import EsmsDialog from '../../components/EsmsDialog';
import TextField from '../../components/FormFields/TextField';

import classes from './ConfirmActionModal.module.css';

const ConfirmActionModal = ({
    children,
    confirmationPhrase,
    confirmationLabel,
    disabled,
    errors,
    imgSrc,
    isLoading,
    onClose,
    onConfirm,
    open,
    title
}) => {
    const [phraseValue, setPhraseValue] = useState('');
    const [doesPhraseMatch, setPhraseMatch] = useState(false);

    useEffect(
        () => {
            setPhraseMatch(false);
            setPhraseValue('');
        },
        [open]
    );

    function handleClose() {
        onClose();
        setPhraseValue('');
    }

    function handleConfirm(event) {
        if (!doesPhraseMatch) {
            event.preventDefault();
            return;
        }
        onConfirm(event);
        if (!event.isDefaultPrevented()) {
            event.preventDefault();
        }
    }

    function handlePhraseChange(event) {
        setPhraseValue(event.target.value);
        setPhraseMatch(
            event.target.value.toUpperCase() === confirmationPhrase.toUpperCase()
        );
    }

    return (
        <EsmsDialog
            confirmText="Confirm"
            disabled={disabled || !doesPhraseMatch}
            errors={errors}
            imgSrc={imgSrc}
            isLoading={isLoading}
            onCancel={handleClose}
            onClose={handleClose}
            onConfirm={handleConfirm}
            open={open}
            title={title}
        >
            {children}
            <p>
                To confirm, please type the word{' '}
                <span className={classes.warning}>
                    {confirmationPhrase.toUpperCase()}
                </span> in the field below.
            </p>
            <form onSubmit={handleConfirm}>
                <TextField
                    autoComplete="off"
                    className={classes.textField}
                    FormHelperTextProps={{
                        classes: {
                            root: classes.input
                        }
                    }}
                    id="confirm-phrase"
                    InputLabelProps={{
                        classes: {
                            focused: classes.labelFocused,
                            root:    classes.label
                        }
                    }}
                    InputProps={{
                        classes: {
                            root: classes.input
                        }
                    }}
                    label={confirmationLabel || 'Confirmation'}
                    onChange={handlePhraseChange}
                    value={phraseValue}
                />
            </form>
        </EsmsDialog>
    );
};

ConfirmActionModal.defaultProps = {
    confirmationPhrase: 'DELETE',
    disabled:           false,
    onClose:            () => {},
    onConfirm:          () => {},
    open:               false
};

ConfirmActionModal.propTypes = {
    children:           node,
    confirmationPhrase: string,
    confirmationLabel:  string,
    disabled:           bool,
    errors:             array,
    imgSrc:             string,
    isLoading:          bool,
    onClose:            func,
    onConfirm:          func,
    open:               bool,
    title:              string.isRequired
};

export default ConfirmActionModal;
